import http from '@/biz/http.mjs'
import useAlert from '@/biz/useAlert.jsx'
import runAsync from '@/script/runAsync.mjs'

export const exportReq = () => () => {
    const alert = useAlert()

    return async function ({expBizFlag, includeBdLogicFlag}) {
        const {prjId, prjPatternId, sVer} = this.data

        await runAsync(
            () => http.post(
                '/prd/export/sa/reqdoc',

                {
                    expBizFlag,
                    includeBdLogicFlag,
                    prjId,
                    prjPatternId,
                    sVer,
                }
            ),

            {action: '导出需求文档'}
        )

        alert.generatingFile()
    }
}

export const exportReq3 = () => () => {
    const alert = useAlert()

    return async function () {
        const {prjId, sVer} = this.data

        await runAsync(
            () => http.post(
                '/prd/export/sa/reqdocsummarySd',
                {prjId, sVer}
            ),

            {action: '导出需求文档'}
        )

        alert.generatingFile()
    }
}

export const exportReq4 = () => () => {
    const alert = useAlert()

    return async function () {
        const {prjId, sVer} = this.data

        await runAsync(
            () => http.post(
                '/prd/export/sa/reqdocsummary4',
                {prjId, sVer}
            ),

            {action: '导出需求文档'}
        )

        alert.generatingFile()
    }
}

export const exportReqAll = () => () => {
    const alert = useAlert()

    return async function ({expBizFlag, fmIds, includeBdLogicFlag}) {
        const {prjId, prjPatternId, sVer} = this.data

        await runAsync(
            () => http.post(
                '/prd/export/sa/reqdocsummary',

                {
                    expBizFlag,
                    fmIds,
                    includeBdLogicFlag,
                    prjId,
                    prjPatternId,
                    sVer,
                }
            ),

            {action: '导出需求文档'}
        )

        alert.generatingFile()
    }
}

export const exportReqAll2 = () => () => {
    const alert = useAlert()

    return async function ({fmIds} = {}) {
        const {prjId, prjPatternId, sVer} = this.data

        await runAsync(
            () => http.post(
                '/prd/export/sa/reqdocsummary2',

                {
                    fmIds,
                    prjId,
                    prjPatternId,
                    sVer,
                }
            ),

            {action: '导出需求文档'}
        )

        alert.generatingFile()
    }
}
